import { Icon } from "src/app/shared/interfaces/icon.interface";

export enum STipoConfiguracion {
  Categorias = "CATEGORIAS",
  Proyectos = "PROYECTOS",
  ProyectosColaborador = "PROYECTOS_COLABORADOR",
  Requerimiento = "REQUERIMIENTO",
  TipoActividad = "TIPO_ACTIVIDAD",
  TipoHora = "TIPO_HORA",
};

export interface HourTypeWithValidations {
  sCodigo: string;
  sDescripcion: string;
  sTipo_Configuracion: string;
  bIsInvalidOption?: boolean;
  firstDate?: string;
  lastDate?: string
};

export interface DateAndStatusTask {
  sEstado: string;
  dDate: string;
  dRegistrationDate: string;
  nReadyMark: number;
};

export enum SEstado {
  Completo = "COMPLETO",
  Falta = "FALTA",
  Incompleto = "INCOMPLETO",
};

export interface Option{
  icon?: Icon,
  sColor?: string,
  sCodigo: string,
  bVisible?: boolean,
  sDescripcion: string,
  sComentario?: string,
  bIsInvalidOption?: boolean,
}